import * as types from './types'

export default {
  [types.WHATS_NEW_SEARCH_RESULT]: (state) => state.searchResult,
  [types.WHATS_NEW_HISTORY]: (state) => state.history,
  [types.WHATS_NEW_MODAL]: (state) => state.modal,
}
